export const ALL_PERMISSIONS = [
  "order_taking", "order_status", "accept_online", "kitchen",
  "delivery", "takeaway", "inventory", "reports", "users",
  "shop_setup", "settings",
];

export const PERMISSION_LABELS = {
  order_taking: "Order Taking",
  order_status: "Order Status",
  accept_online: "Accept Online",
  kitchen: "Kitchen",
  delivery: "Delivery",
  takeaway: "Take Away",
  inventory: "Inventory",
  reports: "Reports",
  users: "User Access",
  shop_setup: "Shop Setup",
  settings: "Settings",
};

export function hasPermission(user, permission) {
  if (!user) return false;
  if (["superadmin", "admin", "shop_admin"].includes(user.role)) return true;
  return (user.permissions || []).includes(permission);
}
